/**
 * Pure predicate for the global ⌘K / Ctrl+K search toggle.
 *
 * Extracted from `ordo-search.tsx` so the guard below is unit-testable — it
 * fixed the app's single largest real client-side bug.
 *
 * The listener is bound to `document`, so it sees EVERY keydown on the page,
 * including synthetic ones. Password managers and browser autofill dispatch
 * `keydown` events with no `key` property at all, so the original
 *
 *     e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey)
 *
 * threw `Cannot read properties of undefined (reading 'toLowerCase')` —
 * 357 events over 30 days (Faro hashes 804620161862695735 and
 * 10375527750810755392), overwhelmingly desktop Edge/Chrome on Windows.
 *
 * Two things keep it safe, and both matter:
 *   1. The modifier is tested FIRST, so the overwhelmingly common
 *      unmodified keystroke never touches `key` at all.
 *   2. `key` is read optionally, because a shim can copy modifier flags onto
 *      an object that is not a real KeyboardEvent.
 *
 * The parameter is typed loosely on purpose: `KeyboardEvent` claims `key` is
 * always a string, and production proved otherwise.
 */
export function isSearchShortcut(event: { key?: string; metaKey?: boolean; ctrlKey?: boolean }): boolean {
  if (!event.metaKey && !event.ctrlKey) {
    return false
  }
  return event.key?.toLowerCase() === 'k'
}
